import { render, staticRenderFns } from "./WordItemSlim.vue?vue&type=template&id=5abdf6dc"
import script from "./WordItemSlim.vue?vue&type=script&lang=js"
export * from "./WordItemSlim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports